export default "__VITE_ASSET__STFn_p5j__"